import { AllCurrenciesT, CryptoCurrenciesE, FiatCurrenciesE } from 'primsell-shared-layer/types'

import euroImgSrc from 'primsell-shared-layer/assets/icons/currency/euro.svg'
import cadImgSrc from 'primsell-shared-layer/assets/icons/currency/cad.svg'
import maticImgSrc from 'primsell-shared-layer/assets/icons/currency/matic.svg'
import ethImgSrc from 'primsell-shared-layer/assets/icons/currency/eth.svg'

export const currencyImageSrcConfig: Record<AllCurrenciesT, string> = {
  [CryptoCurrenciesE.MATIC]: maticImgSrc,
  [CryptoCurrenciesE.WETH]: ethImgSrc,
  [FiatCurrenciesE.EUR]: euroImgSrc,
  [FiatCurrenciesE.CAD]: cadImgSrc,
}
